import React from 'react';
import { AuthenticationSettings } from '../types/authentication_settings/authenticationSettings';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface AuthenticationSettingsContextProps {
  authenticationSettings: Map<string, AuthenticationSettings>;
  setAuthenticationSettings: (settings: Map<string, AuthenticationSettings>) => void;
  companyAuthenticationSettings: AuthenticationSettings | undefined;
  authenticationSettingsForUser: (userId: string) => AuthenticationSettings | undefined;
  authenticationSettingsLoading: boolean;
}

const defaultContext: AuthenticationSettingsContextProps = {
  authenticationSettings: new Map(),
  setAuthenticationSettings: () => {},
  companyAuthenticationSettings: undefined,
  authenticationSettingsForUser: () => undefined,
  authenticationSettingsLoading: false,
};

export const AuthenticationSettingsContext = React.createContext<AuthenticationSettingsContextProps>(defaultContext);

interface AuthenticationSettingsState {
  items: Record<string, any>[];
  loading: boolean;
}

export const authenticationSettingsSlice = createSlice({
  name: 'authenticationSettings',
  initialState: { items: [], loading: true } as AuthenticationSettingsState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    set: (state, action: PayloadAction<AuthenticationSettings[]>) => {
      state.items = [...action.payload.map(as => instanceToPlain(as))];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
